import React, { Fragment } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import {
  DefectsHeader,
  MultipleAssetHeader,
  RepairsHeader,
  DailyLocomotiveSchema,
  TopInfoTableSection,
  customHeader,
  customHeaderRows,
} from "./DailyLocomotiveSchema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { KeyValBox } from "../../../../libraries/ReportGenerator/KeyValBox";
export const DailyLocomotiveReports = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ViewReport data={{}} />;
  }
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(removeDuplicates);
  return decodedReports.map((report, i) => {
    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ViewReport key={i} data={report} {...props} />
      </div>
    );
  });
};
const ViewReport = (props) => {
  const { usecustomHeader, selectedAsset, selectedAssetId } = props;
  const { decodedData, fraHeaderInfo } = props.data;
  return (
    <Fragment>
      {decodedData.map((report, index) => (
        <div key={index + 1} style={{ textAlign: "left" }}>
          <ReportTitleSection title={"Daily Locomotive Inspection Report"} fontSizeOverride={"35px"} />
          {usecustomHeader ? (
            customHeaderDisplay({ ...fraHeaderInfo, engHour: report.summary.engHour ? report.summary.engHour : 0 }, selectedAsset)
          ) : (
            <ReportFraInfoSectionContainer {...props} />
          )}
          {Array.isArray(selectedAsset) && (
            <table className="table-bordered">
              {MultipleAssetHeader.map((e, i) => (
                <ReportTableSectionRenderer section={e} rowsData={{ data: selectedAsset.join(",  ") }} key={i} />
              ))}
            </table>
          )}
          <span className="spacer"></span>
          <table className="table-bordered">
            {TopInfoTableSection.map((section) => (
              <ReportTableSectionRenderer rowsData={report.summary} section={section} />
            ))}
          </table>
          <table className="table-bordered">
            {DailyLocomotiveSchema.map((e, i) => (
              <ReportTableSectionRenderer rowsData={report.summary} section={e} key={i} />
            ))}
          </table>
          <span className="spacer"></span>
          <EqualContentsRow customStyles={{ gap: "20px", alignItems: "flex-start" }}>
            <table className="table-bordered">
              {report.summary.repairsTable &&
                RepairsHeader.map((repair, i) => <ReportTableSectionRenderer section={repair} rowsData={{}} key={i} />)}
              {report.summary.repairsTable &&
                report.summary.repairsTable.map((SingleRow, idex) => {
                  return (
                    <ReportTableSectionRenderer
                      key={idex}
                      rowsData={SingleRow}
                      section={{
                        heights: { header1: "40px" },
                        classes: { header2: "" },
                        inlineData: true,
                        columns: [
                          {
                            title: SingleRow.repairsmadeOn,
                            colSpan: 3,
                            rowSpan: 1,
                            topAlign: true,
                            className: "tbl-text-normal",
                            accessor: "",
                            isTitleOnly: true,
                          },
                          {
                            title: "Inspected",
                            colSpan: 5,
                            rowSpan: 1,
                            topAlign: true,
                            className: "tbl-text-normal",
                            accessor: "repairsDescription",
                            isValueOnly: true,
                          },
                        ],
                      }}
                    />
                  );
                })}
            </table>
            <table className="table-bordered">
              {report.summary.reportDefects &&
                DefectsHeader.map((defect, i) => <ReportTableSectionRenderer section={defect} rowsData={{}} key={i} />)}
              {report.summary.reportDefects &&
                report.summary.reportDefects.map((SingleRow, idex) => {
                  return (
                    <ReportTableSectionRenderer
                      key={idex}
                      rowsData={SingleRow}
                      section={{
                        heights: { header1: "40px" },
                        classes: { header2: "" },
                        inlineData: true,
                        columns: [
                          {
                            title: SingleRow.defectCode,
                            colSpan: 3,
                            rowSpan: 1,
                            topAlign: true,
                            className: "tbl-text-normal",
                            accessor: "",
                            isTitleOnly: true,
                          },
                          {
                            title: "Inspected",
                            colSpan: 5,
                            rowSpan: 1,
                            topAlign: true,
                            className: "tbl-text-normal",
                            accessor: "probDescription",
                            isValueOnly: true,
                          },
                        ],
                      }}
                    />
                  );
                })}
            </table>
          </EqualContentsRow>
        </div>
      ))}
    </Fragment>
  );
};
function customHeaderDisplay(fraHeaderInfo, selectedAsset) {
  if (Array.isArray(selectedAsset) && selectedAsset.length > 0) {
    // fraHeaderInfo.isMultipleAsset = true;
  }
  return (
    <Fragment>
      <span className="spacer"></span>
      <table style={{ border: "2px solid black" }}>
        {customHeaderRows.map((e, i) => (
          <ReportTableSectionRenderer section={e} rowsData={fraHeaderInfo} key={i} />
        ))}
      </table>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/DailyLocomotiveInspection/DailyLocomotiveReport.jsx